import React from 'react'
import PropTypes from 'prop-types'

import { IconButton, SvgIcon } from '@material-ui/core'
import { mdiPencil } from '@mdi/js'

class EditButton extends React.Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  }

  render() {
    const { label, onClick } = this.props

    return (
      <IconButton aria-label={label} onClick={onClick}>
        <SvgIcon>
          <path d={mdiPencil} />
        </SvgIcon>
      </IconButton>
    )
  }
}

export default EditButton
